import React from "react";
import { CampaignType } from "../types/campaignType.types";
import { toast } from "react-hot-toast";
import { campaigns } from "../Services/APIService";

export const getCampaignTypeTableColumns = (
  handleEdit: (campaignType: CampaignType) => void
) => [
  {
    name: "Campaign Type",
    selector: (row: CampaignType) => row.name,
    sortable: true,
    cell: (row: CampaignType) => (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            backgroundColor: "rgb(167 133 144)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "10px",
            fontWeight: "bold",
          }}
        >
          {row.name.charAt(0).toUpperCase()}
        </div>
        <span style={{ fontWeight: "500", color: "#33475b" }}>
          {row.name}
        </span>
      </div>
    ),
    width: "300px",
  },
  {
      name: "Status",
      selector: (row: CampaignType) => row.isActive,
      sortable: true,
      cell: (row: CampaignType) => {
        const isActive =
          typeof row.isActive === "boolean"
            ? row.isActive
            : row.isActive === "true";
        return (
          <span className={isActive ? "active-status" : "inactive-status"}>
            {isActive ? "ACTIVE" : "INACTIVE"}
          </span>
        );
      },
      width: "250px",
    },
  
  {
    name: "",
    cell: (row: CampaignType) => (
      <div className="action-cell">
        <button
          className="action-button edit-button"
          onClick={() => handleEdit(row)}
          title="Edit"
        >
          <i className="bi bi-pencil-square"></i>
        </button>
        <button className="action-button more-button" title="More options">
          <i className="bi bi-three-dots"></i>
        </button>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    width: "80px",
  },
];